import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mutateImageUrl } from '../../wordpress';

/**
 * Navigation accessories component
 *
 * Lists the selected accessories when they've been selected
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
const NavigationAccessories = ({ selected, active, onSelect, onEdit, onRemove, displayProducts, accessoriesItem }) => {
    const accessoriesSections = [
        {
            id: 'accessory1',
            title: 'Accessory 1',
            emptyText: 'Choose an accessory',
            handle: 'all-accessories',
        },
        // {
        //     id: 'accessory2',
        //     title: 'Accessory 2',
        //     emptyText: 'Choose an accessory',
        //     handle: 'all-accessories',
        // }, {
        //     id: 'accessory3',
        //     title: 'Accessory 3',
        //     emptyText: 'Choose an accessory',
        //     handle: 'all-accessories',
        // }, {
        //     id: 'accessory4',
        //     title: 'Accessory 4',
        //     emptyText: 'Choose an accessory',
        //     handle: 'all-accessories',
        // },
    ];

    return (
        <li className="navigation-accessories">
            <h3>{accessoriesItem.title}</h3>
            <ul>
                {accessoriesSections.map((accecssoryNavItem, index) => {
                    const item = selected[index];
                    let imgSrc = null;
                    if (item?.attributes && item.attributes?.image?.url) {
                        imgSrc = mutateImageUrl(item.attributes.image.url, 480, 480);
                    } else if (item?.productMatchAttr?.image?.url) {
                        imgSrc = item.productMatchAttr.image.url;
                    } else if (item?.product?.featuredImage?.url) {
                        imgSrc = item.product.featuredImage.url;
                    }

                    let classes = classNames('navigation-item', `navigation-accessories-${accecssoryNavItem.title}`, {
                        'navigation-item-active': active === `${accecssoryNavItem.id}`,
                        'navigation-accessories-hasproduct': item !== null,
                    });

                    return (
                        <li
                            key={accecssoryNavItem.id}
                            className={classes}
                            onClick={() => {
                                // onSelect(`${accecssoryNavItem.id}`);
                                displayProducts(accecssoryNavItem);
                            }}
                        >
                            {imgSrc && <img src={imgSrc} alt="" className="navigation-item__image" />}
                        </li>
                    );
                })}
            </ul>
        </li>
    );
};

NavigationAccessories.propTypes = {
    selected: PropTypes.array.isRequired,
    active: PropTypes.string,
    onSelect: PropTypes.func,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    displayProducts: PropTypes.func,
};

NavigationAccessories.defaultProps = {
    active: null,
    onSelect: () => {},
    onEdit: () => {},
    onRemove: () => {},
    displayProducts: () => {},
};

export default NavigationAccessories;
